import React from "react";
import { withRouter } from "react-router-dom";
import shareIcon from '../../../../../public/images/icons/share-icon-blue.png';
import GoogleBadge from "./google-play-badge.png";
import AppleBadge from "./app-store-badge.png";
import './styles.css';

let appStoreLink,
    googlePlayLink;

const setLocalLinks = () => {
  switch(process.env.REGION) {
    case "au":
      appStoreLink = "https://apps.apple.com/au/app/ticketek-au/id454379421";
      googlePlayLink = "https://play.google.com/store/apps/details?id=au.com.ticketek";
      break;
    case "uk":
      appStoreLink = "https://apps.apple.com/gb/app/ticketek-uk/id1502496040";
      googlePlayLink = "https://play.google.com/store/apps/details?id=uk.co.ticketek"
      break;
    case "nz":
      appStoreLink = "https://apps.apple.com/nz/app/ticketek-nz/id583264123";
      googlePlayLink = "https://play.google.com/store/apps/details?id=nz.co.ticketek.new";
      break;
    default:
      appStoreLink = "https://apps.apple.com/au/app/ticketek-au/id454379421";
      googlePlayLink = "https://play.google.com/store/apps/details?id=au.com.ticketek";
      break;
  }
}
setLocalLinks();

export const DownloadAppComponent = function() {
  return (
    <div>
      <img src={shareIcon} className="share-icon"/>
      <h1>
        Download the Ticketek App to accept and view your ticket.
      </h1>
      <p className="app-downloads">
        <a href={ appStoreLink }>
          <img alt="Download on the Apple App Store" src={AppleBadge} />
        </a>
        <a href="https://play.google.com/store/apps/details?id=au.com.ticketek">
          <img alt="Download Google Play Store" src={GoogleBadge} />
        </a>
      </p>
    </div>
  );
};

export const DownloadApp = withRouter(DownloadAppComponent);
